import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import API_ROUTES from '../../api';
import axios from 'axios';
import httpClient from '../../shared/api/httpClient';
import {
    Card, Grid, NavBar, Popup,
    Toast, Dialog,
    PullToRefresh,
    CapsuleTabs
} from 'antd-mobile';
import '../../styles/components/match-members.css'
import './index.css'
import { TravelOutline, CalendarOutline, ExclamationCircleOutline, CheckOutline, DeleteOutline, EditSOutline } from 'antd-mobile-icons'
import UserList from './userList';

import GameActivity from './gameActivity';
import AddTempMember from './addTempMember';
import DinnerInfo from '../../Dinner/DinnerInfo';
import Icon from '../../icon';
import GameTitleTeam from '../ApplicateTwo/gameTitleTeam';
import ChooseCaptain from './chooseCaptain';
import './recruit-overrides.css';
import './signup-polish.css';
import OthersTeam from './othersTeam';
import { useGameRouteId } from '../../features/match/hooks/useGameRouteId';
import { useAuth } from '../../app/providers/AuthProvider';
import OpponentPickerPopup from './OpponentPickerPopup';
import RegistrationActions from '../../features/match/components/RegistrationActions';


export default function ApplicateOne(props) {

    const navigate = useNavigate()
    const { memberInfo } = useAuth()
    const gameId = useGameRouteId('signup');

    const [gameDetail, setGameDetail] = useState({})
    const [captainVisible, setCaptainVisible] = useState(false)
    const [captainChoose, setCaptainChoose] = useState([])
    const [memberListInfo, setMemberListInfo] = useState([])
    const [opponentPopupVisible, setOpponentPopupVisible] = useState(false)

    // 仅保留提交时需要的加载状态写入函数，当前界面不直接展示该状态值。
    const [, setCaptainLoading] = useState(false)
    const [allowcationLoading, setAllowcationLoading] = useState(false)

    // 结束报名失败时展示服务端原因，避免只看到笼统的“系统错误”。
    const showAllocationError = error => Toast.show({
        icon: 'fail',
        content: error?.response?.data?.msg || error?.response?.data?.message || '结束报名失败，请稍后重试',
    })

    // 结束报名接口接收表单参数，统一客户端同时携带长期登录凭证。
    const submitAllocation = values => httpClient.post(
        API_ROUTES.game_allocation,
        new URLSearchParams(Object.entries(values).filter(([, value]) => value != null))
    )

    const [mvpDataInfo, setMvpDataInfo] = useState({ checking: true })
    // 内讧赛投票提示保留在详情页，报名门槛统一交给共用操作组件判断。
    const isInternalGame = Number(gameDetail?.gameType) === 3
    const currentSignupType = memberListInfo.find(item => String(item.id) === String(memberInfo?.id))?.gameType
    // 管理员代报名可直接操作，不显示面向普通队员的投票门槛提示。
    const mvpVotePending = Number(memberInfo?.admin) !== 1 && isInternalGame && !mvpDataInfo?.checking && mvpDataInfo?.gameId && !mvpDataInfo?.likeMemberId

    // Team naming logic synchronized with GameTitleTeam
    const getTeamName = (teamIndex) => {
        if (teamIndex === 1) {
            if (gameDetail?.greenName) return gameDetail.greenName;
            if (gameDetail?.gameType === 2) return "华西科朋足球队";
            if (gameDetail?.greenCaptain?.name) return gameDetail.greenCaptain.name.charAt(0) + '队';
            return 'A队';
        } else if (teamIndex === 2) {
            if (gameDetail?.redName) return gameDetail.redName;
            if (gameDetail?.redCaptain?.name) return gameDetail.redCaptain.name.charAt(0) + '队';
            return 'B队';
        }
        return 'Team'
    }


    const getGameDetail = useCallback(() => {
        Toast.show({
            icon: 'loading',
            duration: 0,
        })
        axios.get(API_ROUTES.game_info, {
            params: {
                id: gameId
            }
        })
            .then(function (response) {
                const ditailInfo = response.data.data
                if (ditailInfo.status !== '招募中') {
                    navigate('/home')
                } else {
                    setGameDetail(ditailInfo)
                    if (Number(ditailInfo?.gameType) === 3 && memberInfo?.temp !== '1') {
                        setMvpDataInfo({ checking: true })
                        axios.get(API_ROUTES.game_mvpStatus, {
                            params: {
                                memberId: memberInfo?.id,
                            }
                        }, null)
                            .then(function (response) {
                                if (response.data?.code !== 200) throw new Error(response.data?.msg || '查询失败')
                                setMvpDataInfo({ ...(response.data.data || {}), checking: false })
                            })
                            .catch(function (error) {
                                setMvpDataInfo({ checking: true, error: true })
                                Toast.show({
                                    icon: 'fail',
                                    content: 'MVP 投票状态查询失败，请下拉刷新重试'
                                })
                            })
                            .finally(() => {
                                Toast.clear()
                            });
                    } else {
                        setMvpDataInfo({ checking: false })
                        Toast.clear()
                    }
                }
            })
            .catch(function (error) {
                console.error('Error fetching user list:', error);
            })
            .finally(() => {
            });
    }, [gameId, memberInfo?.id, memberInfo?.temp, navigate])

    const getUserListInfo = useCallback(() => {
        Toast.show({
            icon: 'loading',
        })
        axios.get(API_ROUTES.member_gameList, {
            params: {
                gameId: gameId
            }
        })
            .then(function (response) {
                if (response.data.code === 200) {
                    setMemberListInfo(response.data.data)
                    Toast.clear()
                } else {
                    Toast.show({
                        content: "获取用户列表失败！请刷新重试！",
                        icon: 'fail',
                    })
                }
            })
            .catch(function (error) {
                Toast.show({
                    content: "获取用户列表失败！请刷新重试！",
                    icon: 'fail',
                })
            })
            .finally(() => {
            });
    }, [gameId])

    useEffect(() => {
        if (!gameId) return
        getGameDetail()
        getUserListInfo()
    }, [gameId, getGameDetail, getUserListInfo]);

    const handleInnderfunction = () => {
        getUserListInfo()
        getGameDetail()
    }

    // 取消比赛沿用原有确认弹窗和接口调用，仅复用到地址行的图标按钮。
    const handleCancelGame = () => {
        Dialog.confirm({
            className: 'position-selection-dialog',
            title: (
                <div className="position-dialog-header">
                    <div className="position-dialog-title" style={{ color: '#ef4444' }}>⚠️ 取消比赛</div>
                    <div className="position-dialog-subtitle">此操作不可撤销</div>
                </div>
            ),
            content: (
                <div className="position-dialog-content">
                    <div style={{
                        textAlign: 'center',
                        padding: '10px 0',
                        color: '#86909C',
                        fontSize: '15px'
                    }}>
                        确认后当前的比赛将被取消！
                    </div>
                </div>
            ),
            onConfirm: () => {
                setAllowcationLoading(true)
                axios.post(API_ROUTES.game_changeGameInfo, {
                    id: gameDetail.id,
                    status: 4
                }, null)
                    .then(function (response) {
                        if (response.data.code === 200) {
                            navigate('/home');
                        } else {
                            Toast.show({
                                icon: <ExclamationCircleOutline />,
                                content: response.data.msg,
                            })
                        }
                    })
                    .catch(function () {
                        Toast.show({
                            icon: 'fail',
                            content: "操作失败，请联系管理员！",
                        })
                    })
                    .finally(() => {
                        setAllowcationLoading(false)
                    });
            },
        })
    }

    const mainImage = (member) => {
        // 门将和裁判始终保持特殊头像
        if (member?.gameRole === 1 && member?.gameType === 0) { // 门将
            const image = member.memberImageList?.find(item => item.type === 4)?.image;
            return image ? image + Icon.ImageFooter : Icon.KEPENG_LOGO;
        }
        if (member?.gameType === 1 || member?.gameType === 2 || member?.gameType === 3) { // 裁判
            const image = member.memberImageList?.find(item => item.type === 3)?.image;
            return image ? image + Icon.ImageFooter : Icon.REFEREE_DEFALT_AVATAR;
        }

        // 检查是否存在两个队长
        const isTwoCaptains = gameDetail?.redCaptain && gameDetail?.greenCaptain;

        if (isTwoCaptains && member?.gameType === 0) {
            // 在上场队员列表中，队长颜色跟其他队员一样 (Purple Type 5)
            const image = member.memberImageList?.find(item => item.type === 5)?.image;
            return image ? image + Icon.ImageFooter : Icon.PURPLE_DEFAILT_AVATAR;
        }

        // 默认显示 (Type 0)
        const image = member?.memberImageList?.find(item => item.type === 0)?.image;
        return image ? image + Icon.ImageFooter : Icon.KEPENG_LOGO;
    };

    const handleSignUp = (type, remark, memberId) => {
        Toast.show({
            icon: 'loading',
        })
        axios.post(API_ROUTES.game_join, {
            gameId: gameDetail.id,
            memberId: memberId,
            gameType: type,
            remark: remark
        }, null)
            .then(function (response) {
                if (response.data.code === 200) {
                    Toast.show({
                        icon: 'success',
                        content: '操作成功！',
                        afterClose: () => {
                            getGameDetail()
                            getUserListInfo()
                        }
                    })
                } else {
                    Toast.show({
                        icon: 'fail',
                        content: response.data?.msg || '操作失败，请重试',
                        afterClose: () => {
                            Toast.clear()
                        }
                    })
                }
            })
            .catch(function (error) {
                Toast.show({
                    icon: 'fail',
                    content: '操作失败，请联系管理员！',
                    afterClose: () => {
                        Toast.clear()
                    }
                })
            })
            .finally(() => {

            });
    }

    const handleUpdateCaptain = (dto) => {
        Toast.show({
            icon: 'loading',
            content: '正在更新队长...',
            duration: 0
        });
        axios.post(API_ROUTES.game_updateCaptain, dto)
            .then(res => {
                if (res.data.code === 200) {
                    Toast.show({
                        icon: 'success',
                        content: '更新成功'
                    });
                    getGameDetail();
                } else {
                    Toast.show({
                        icon: 'fail',
                        content: res.data.msg || '更新失败'
                    });
                }
            })
            .catch(err => {
                Toast.show({
                    icon: 'fail',
                    content: '网络错误'
                });
            });
    }

    return (
        <div className="applicate-container has-unified-nav match-member-scope">
            <NavBar
                className="unified-navbar fixed"
                onBack={() => window.history.back()}
            >
                比赛报名招募
            </NavBar>
            <PullToRefresh
                onRefresh={async () => {
                    getGameDetail()
                    getUserListInfo()
                }}
            >
                <div className='body_detail' >
                    <GameTitleTeam gameDetail={gameDetail} getGameDetail={getGameDetail} />
                    <Card className="applicate-main-card">
                        <div className="applicate-hero-panel">
                            <div className="applicate-date-header">
                                <span className="applicate-date-value"><CalendarOutline className="applicate-date-icon" />{gameDetail.startDate}</span>
                                <span className="applicate-week-value">{gameDetail.week}</span>
                            </div>
                            <div className="applicate-location-link">
                                <TravelOutline className="applicate-location-icon" />
                                <span title={gameDetail.address}>{gameDetail.address}</span>
                                {memberInfo && memberInfo.admin === 1 && (
                                    <div className="applicate-game-icon-actions">
                                        {/* 修改入口移到删除入口之前，两者使用统一尺寸的图标按钮。 */}
                                        <button
                                            type="button"
                                            className="applicate-game-icon-btn applicate-edit-game-icon"
                                            aria-label="修改比赛"
                                            title="修改比赛"
                                            onClick={() => { navigate(`/gameUpdate?gameId=${gameDetail.id}`, { state: { gameDetail: gameDetail } }) }}
                                        >
                                            <EditSOutline />
                                        </button>
                                        <button
                                            type="button"
                                            className="applicate-game-icon-btn applicate-cancel-game-icon"
                                            aria-label="取消比赛"
                                            title="取消比赛"
                                            disabled={allowcationLoading}
                                            onClick={handleCancelGame}
                                        >
                                            <DeleteOutline />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>

                        <CapsuleTabs defaultActiveKey={'1'} >
                            <CapsuleTabs.Tab title='比赛报名' key="1">

                                {gameDetail.gameType === 4 ?
                                    <GameActivity gameDetail={gameDetail} getGameDetail={getGameDetail} getUserListInfo={getUserListInfo} memberInfo={memberInfo} />
                                    :
                                    <div className="applicate-match-content">
                                        {memberInfo && memberInfo.admin === 1 ?
                                            <div className="applicate-admin-panel applicate-admin-panel--flow">
                                                {/* 修改比赛已移至地址行，其他管理操作继续共用当前布局。 */}
                                                <div className="applicate-admin-actions">
                                                    <AddTempMember gameDetail={gameDetail} getGameDetailInfo={getUserListInfo} />
                                                    <Grid columns={3} gap={8} className="applicate-admin-grid">
                                                    {[1, 2].includes(gameDetail?.gameType) ?
                                                        <>
                                                            <Grid.Item span={1}>
                                                                <button
                                                                    className="admin-action-btn btn--success"
                                                                    style={{ width: '100%' }}
                                                                    disabled={!gameDetail.redCaptain}
                                                                    onClick={() => setCaptainVisible(true)}
                                                                >
                                                                    {allowcationLoading ? '处理中...' : '报名结束'}
                                                                </button>
                                                            </Grid.Item>
                                                            <Grid.Item span={1}>
                                                                <button
                                                                    className="admin-action-btn btn--warning"
                                                                    style={{ width: '100%' }}
                                                                    onClick={() => setOpponentPopupVisible(true)}
                                                                >
                                                                    {gameDetail.redCaptain ? '管理对手' : '添加对手'}
                                                                </button>
                                                            </Grid.Item>
                                                        </>
                                                        :
                                                        <Grid.Item span={2}>
                                                            <button
                                                                className="admin-action-btn btn--success"
                                                                style={{ width: '100%' }}
                                                                onClick={() => {
                                                                    if (gameDetail.redCaptain && gameDetail.greenCaptain) {
                                                                        Dialog.confirm({
                                                                            className: 'position-selection-dialog',
                                                                            title: (
                                                                                <div className="position-dialog-header">
                                                                                    <div className="position-dialog-title">确认队长</div>
                                                                                    <div className="position-dialog-subtitle">确认当前系统安排的队长</div>
                                                                                </div>
                                                                            ),
                                                                            content: (
                                                                                <div className="position-dialog-content">
                                                                                    <div style={{
                                                                                        textAlign: 'center',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        padding: '20px 0',
                                                                                        color: 'black',
                                                                                        fontSize: '16px',
                                                                                        fontWeight: '600'
                                                                                    }}>
                                                                                        <div>{gameDetail?.greenCaptain?.name}</div>
                                                                                        <span style={{ fontSize: '16px', color: '#1D2129', margin: '0px 10px' }}>VS</span>
                                                                                        <div>{gameDetail?.redCaptain?.name}</div>
                                                                                    </div>
                                                                                </div>
                                                                            ),
                                                                            onConfirm: () => {
                                                                                submitAllocation({ id: gameDetail.id }).then(function (response) {
                                                                                    if (response.data.code === 200) {
                                                                                        navigate(`/games/${gameDetail.id}/ready`);
                                                                                    } else {
                                                                                        Toast.show({ icon: <ExclamationCircleOutline />, content: response.data.msg });
                                                                                    }
                                                                                }).catch(showAllocationError);
                                                                            },
                                                                            onCancel: () => setCaptainVisible(true),
                                                                        });
                                                                    } else {
                                                                        setCaptainVisible(true);
                                                                    }
                                                                }}
                                                            >
                                                                {allowcationLoading ? '处理中...' : '报名结束'}
                                                            </button>
                                                        </Grid.Item>
                                                    }
                                                    </Grid>
                                                </div>
                                                <Popup
                                                    visible={captainVisible}
                                                    onMaskClick={() => {
                                                        setCaptainChoose([])
                                                        setCaptainVisible(false)
                                                    }}
                                                    destroyOnClose
                                                    className="captain-popup-glass"
                                                >
                                                    <div className="captain-selection-header">
                                                        <div className="captain-selection-title">选择场上队长</div>
                                                        <div className="captain-selection-subtitle">
                                                            {[1, 2].includes(gameDetail?.gameType) ? '由于是外战模式，请选择 1 名我方队长' : '请选择 2 名带队队长进行分队'}
                                                        </div>
                                                    </div>

                                                    <div className="captain-selection-list">
                                                        {/* Constant Members Section */}
                                                        {memberListInfo?.filter(item =>
                                                            item.gameType === 0 && item.tempMember === null && item.standingMember === 1
                                                        ).map(item => {
                                                            const isSelected = captainChoose.includes(item.id);
                                                            return (
                                                                <div
                                                                    key={item.id}
                                                                    className={`elite-item-wrapper ${isSelected ? 'is-selected' : ''}`}
                                                                    onClick={() => {
                                                                        const isExternal = [1, 2].includes(gameDetail?.gameType);
                                                                        const limit = isExternal ? 1 : 2;
                                                                        if (isSelected) {
                                                                            setCaptainChoose(captainChoose.filter(id => id !== item.id));
                                                                        } else {
                                                                            if (captainChoose.length < limit) {
                                                                                setCaptainChoose([...captainChoose, item.id]);
                                                                            } else {
                                                                                Toast.show({ content: isExternal ? '只能选择 1 名队长' : '只能选择 2 名队长' });
                                                                            }
                                                                        }
                                                                    }}
                                                                >
                                                                    <div className="elite-item-card mini-compact">
                                                                        <div className="premium-player-card">
                                                                            <div className="premium-avatar-box">
                                                                                <img src={mainImage(item)} className="premium-avatar" alt={item.name} />
                                                                            </div>
                                                                            <div className="premium-content">
                                                                                <span className="premium-name">{item.name}</span>
                                                                            </div>
                                                                            <div className="selection-indicator">
                                                                                {isSelected && <CheckOutline fontSize={18} />}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}

                                                        <div className="custom-elite-divider">
                                                            <span className="divider-line" />
                                                            <span className="divider-text">普通成员</span>
                                                            <span className="divider-line" />
                                                        </div>

                                                        {/* Regular Members Section */}
                                                        {memberListInfo?.filter(item =>
                                                            item.gameType === 0 && item.tempMember === null && item.standingMember !== 1
                                                        ).map(item => {
                                                            const isSelected = captainChoose.includes(item.id);
                                                            return (
                                                                <div
                                                                    key={item.id}
                                                                    className={`elite-item-wrapper ${isSelected ? 'is-selected' : ''}`}
                                                                    onClick={() => {
                                                                        const isExternal = [1, 2].includes(gameDetail?.gameType);
                                                                        const limit = isExternal ? 1 : 2;
                                                                        if (isSelected) {
                                                                            setCaptainChoose(captainChoose.filter(id => id !== item.id));
                                                                        } else {
                                                                            if (captainChoose.length < limit) {
                                                                                setCaptainChoose([...captainChoose, item.id]);
                                                                            } else {
                                                                                Toast.show({ content: isExternal ? '只能选择 1 名队长' : '只能选择 2 名队长' });
                                                                            }
                                                                        }
                                                                    }}
                                                                >
                                                                    <div className="elite-item-card mini-compact">
                                                                        <div className="premium-player-card">
                                                                            <div className="premium-avatar-box">
                                                                                <img src={mainImage(item)} className="premium-avatar" alt={item.name} />
                                                                            </div>
                                                                            <div className="premium-content">
                                                                                <span className="premium-name">{item.name}</span>
                                                                            </div>
                                                                            <div className="selection-indicator">
                                                                                {isSelected && <CheckOutline fontSize={18} />}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>

                                                    <div className="captain-selection-footer">
                                                        <button
                                                            className={`admin-action-btn btn--glass`}
                                                            disabled={[1, 2].includes(gameDetail?.gameType)}
                                                            onClick={() => {
                                                                Dialog.confirm({
                                                                    className: 'position-selection-dialog',
                                                                    title: (
                                                                        <div className="position-dialog-header">
                                                                            <div className="position-dialog-title">🤖 自动分配</div>
                                                                            <div className="position-dialog-subtitle">由系统随机指定两名队长</div>
                                                                        </div>
                                                                    ),
                                                                    content: (
                                                                        <div className="position-dialog-content">
                                                                            <div style={{ textAlign: 'center', padding: '10px 0', color: '#86909C' }}>
                                                                                确认所有人员报名情况无误，点击之后进入分队！
                                                                            </div>
                                                                        </div>
                                                                    ),
                                                                    onConfirm: () => {
                                                                        setCaptainLoading(true)
                                                                        setAllowcationLoading(true)
                                                                        submitAllocation({
                                                                            id: gameId,
                                                                            flag: 1
                                                                        }).then(function (response) {
                                                                            if (response.data.code === 200) {
                                                                                navigate(`/games/${gameId}/ready`);
                                                                            } else {
                                                                                Toast.show({ icon: <ExclamationCircleOutline />, content: response.data.msg });
                                                                            }
                                                                        }).catch(showAllocationError).finally(() => {
                                                                            setAllowcationLoading(false)
                                                                            setCaptainLoading(false)
                                                                        });
                                                                    }
                                                                })
                                                            }}
                                                        >
                                                            自动分配
                                                        </button>
                                                        <button
                                                            className="admin-action-btn btn--primary"
                                                            onClick={() => {
                                                                if ([1, 2].includes(gameDetail.gameType)) {
                                                                    if (captainChoose.length === 1) {
                                                                        const captain1 = memberListInfo.find(item => item.id === captainChoose[0]);
                                                                        Dialog.confirm({
                                                                            className: 'position-selection-dialog',
                                                                            title: (
                                                                                <div className="position-dialog-header">
                                                                                    <div className="position-dialog-title">确认队长</div>
                                                                                    <div className="position-dialog-subtitle">我方主队队长报名</div>
                                                                                </div>
                                                                            ),
                                                                            content: (
                                                                                <div className="position-dialog-content">
                                                                                    <div style={{ textAlign: 'center', padding: '15px 0', color: '#f8fafc', fontSize: '16px', fontWeight: '600' }}>
                                                                                        👑 {captain1.name}
                                                                                    </div>
                                                                                    <div style={{ textAlign: 'center', color: '#4E5969', fontSize: '13px' }}>
                                                                                        点击确认进入分队流程
                                                                                    </div>
                                                                                </div>
                                                                            ),
                                                                            onConfirm: () => {
                                                                                setAllowcationLoading(true)
                                                                                submitAllocation({
                                                                                    id: gameId,
                                                                                    captain1: captain1.id,
                                                                                }).then(function (response) {
                                                                                    if (response.data.code === 200) {
                                                                                        navigate(`/games/${gameId}/ready`);
                                                                                    } else {
                                                                                        Toast.show({ icon: <ExclamationCircleOutline />, content: response.data.msg });
                                                                                    }
                                                                                }).catch(showAllocationError).finally(() => {
                                                                                    setAllowcationLoading(false)
                                                                                });
                                                                            }
                                                                        })
                                                                    } else {
                                                                        Toast.show({ icon: 'fail', content: '外战只能选择一名队长' })
                                                                    }
                                                                } else {
                                                                    if (captainChoose.length === 2) {
                                                                        const captain1 = memberListInfo.find(item => item.id === captainChoose[0]);
                                                                        const captain2 = memberListInfo.find(item => item.id === captainChoose[1]);
                                                                        Dialog.confirm({
                                                                            className: 'position-selection-dialog',
                                                                            title: (
                                                                                <div className="position-dialog-header">
                                                                                    <div className="position-dialog-title">确认带队队长</div>
                                                                                    <div className="position-dialog-subtitle">确认以下两名成员作为队长</div>
                                                                                </div>
                                                                            ),
                                                                            content: (
                                                                                <div className="position-dialog-content">
                                                                                    <div style={{ textAlign: 'center', padding: '15px 0', color: '#f8fafc', fontSize: '16px', fontWeight: '600' }}>
                                                                                        🔴 {captain1.name} & 🟢 {captain2.name}
                                                                                    </div>
                                                                                    <div style={{ textAlign: 'center', color: '#4E5969', fontSize: '13px' }}>
                                                                                        系统将根据数据自动计算最优阵容
                                                                                    </div>
                                                                                </div>
                                                                            ),
                                                                            onConfirm: () => {
                                                                                Toast.show({ icon: 'loading', content: '正在智能排位中...', duration: 0 })
                                                                                setAllowcationLoading(true)
                                                                                submitAllocation({
                                                                                    id: gameId,
                                                                                    captain1: captain1.id,
                                                                                    captain2: captain2.id
                                                                                }).then(function (response) {
                                                                                    if (response.data.code === 200) {
                                                                                        navigate(`/games/${gameId}/ready`);
                                                                                    } else {
                                                                                        Toast.show({ icon: <ExclamationCircleOutline />, content: response.data.msg });
                                                                                    }
                                                                                }).catch(showAllocationError).finally(() => {
                                                                                    setAllowcationLoading(false)
                                                                                });
                                                                            }
                                                                        })
                                                                    } else {
                                                                        Toast.show({ icon: 'fail', content: '请选择两名队长' })
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            确认带队
                                                        </button>
                                                    </div>
                                                </Popup>
                                            </div>
                                            : null
                                        }

                                        {mvpVotePending && memberInfo?.temp !== '1' && (
                                            <div className={`applicate-mvp-signup-note ${mvpDataInfo?.clickInfo ? 'is-required' : ''}`}>
                                                <span>{mvpDataInfo?.clickInfo
                                                    ? '你参加了上一场内讧赛，请先完成 MVP 投票再报名。'
                                                    : '上一场内讧赛 MVP 正在评选，可自愿投票；本场可直接报名。'}</span>
                                                <button type="button" onClick={() => navigate(`/games/${mvpDataInfo.gameId}/history`)}>去投票 ›</button>
                                            </div>
                                        )}
                                        {/* 首页与详情页使用同一组状态卡和操作面板，避免按钮与弹窗出现两套样式。 */}
                                        <div className="applicate-registration-actions">
                                            <RegistrationActions
                                                gameId={gameDetail.id}
                                                gameType={gameDetail.gameType}
                                                memberId={memberInfo?.id}
                                                currentType={currentSignupType}
                                                counts={{
                                                    signup: memberListInfo.filter(item => item.gameType != null && Number(item.gameType) >= 0 && Number(item.gameType) <= 4).length,
                                                    leave: memberListInfo.filter(item => Number(item.gameType) === 5).length,
                                                    pending: memberListInfo.filter(item => Number(item.gameType) === 6).length,
                                                }}
                                                mvpState={mvpDataInfo}
                                                isAdmin={Number(memberInfo?.admin) === 1}
                                                disabled={memberInfo?.temp === '1'}
                                                onChanged={() => { getGameDetail(); getUserListInfo(); }}
                                            />
                                        </div>

                                        {gameDetail?.gameType === 3 &&
                                            <ChooseCaptain
                                                gameDetail={gameDetail}
                                                memberList={memberListInfo}
                                                greenTeamName={getTeamName(1)}
                                                redTeamName={getTeamName(2)}
                                                memberInfo={memberInfo}
                                                onUpdateCaptain={handleUpdateCaptain}
                                            />
                                        }

                                        <UserList gameDetail={gameDetail} runFunction={handleInnderfunction} memberList={memberListInfo} />

                                        <OthersTeam gameDetail={gameDetail} memberInfo={memberListInfo} currentUser={memberInfo} handleSignUp={handleSignUp} />
                                    </div>
                                }
                            </CapsuleTabs.Tab>
                            <CapsuleTabs.Tab title='聚餐报名' key="2" disabled={!gameDetail?.id}>
                                <DinnerInfo gameDetail={gameDetail} memberListInfo={memberListInfo} />
                            </CapsuleTabs.Tab>
                        </CapsuleTabs>
                    </Card>
                </div>
            </PullToRefresh>
            <OpponentPickerPopup
                visible={opponentPopupVisible}
                onClose={() => setOpponentPopupVisible(false)}
                gameDetail={gameDetail}
                memberList={memberListInfo}
                onSaved={() => {
                    getGameDetail()
                    getUserListInfo()
                }}
            />
        </div >
    )
}
